<template>
    <section class="promotional-container">
        <div class="page-container">
            <div class="heading text-center">
            </div>
            <div class="promotional-panel">
                <promotion-component></promotion-component>
            </div>
            <div class="text-center">
                <img class="horz_logo w-200" src="/images/white_logo_hor.svg">
            </div>
        </div>
    </section>
</template>

<script>
import PromotionComponent from './PromotionComponent.vue';
import PromotionalComponentOctober from './PromotionalComponentOctober.vue';
    export default {
        components: { PromotionComponent, PromotionalComponentOctober },
        name: "PromotionalOffersComponent",
    }
</script>